export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}
